import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHide = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 72,
	height: 72,
	viewBox: "0 0 72 72",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M22.0673 49.5955C26.1752 52.4717 30.9483 54 35.8232 54C40.698 54 45.4711 52.4717 49.579 49.5955C53.6869 46.7193 57.9517 40.8473 60 36H55.5218C53.7814 40.1187 51.0019 43.6059 47.5114 46.0498C44.021 48.4936 39.9653 49.7922 35.8232 49.7922C31.6811 49.7922 27.6254 48.4936 24.1349 46.0498C20.6445 43.6059 17.865 40.1187 16.1246 36H12C14.0483 40.8473 17.9595 46.7193 22.0673 49.5955Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M22.0673 22.4045C26.1752 19.5283 30.9483 18 35.8232 18C40.698 18 45.4711 19.5283 49.579 22.4045C53.6869 25.2807 57.9517 31.1527 60 36H55.5218C53.7814 31.8813 51.0019 28.3941 47.5114 25.9502C44.021 23.5064 39.9653 22.2078 35.8232 22.2078C31.6811 22.2078 27.6254 23.5064 24.1349 25.9502C20.6445 28.3941 17.865 31.8813 16.1246 36H12C14.0483 31.1527 17.9595 25.2807 22.0673 22.4045Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M36.2373 32.0851C33.9441 32.0851 32.0851 33.9441 32.0851 36.2373C32.0851 38.5305 33.9441 40.3895 36.2373 40.3895C38.5305 40.3895 40.3895 38.5305 40.3895 36.2373C40.3895 33.9441 38.5305 32.0851 36.2373 32.0851ZM28.2373 36.2373C28.2373 31.819 31.819 28.2373 36.2373 28.2373C40.6556 28.2373 44.2373 31.819 44.2373 36.2373C44.2373 40.6556 40.6556 44.2373 36.2373 44.2373C31.819 44.2373 28.2373 40.6556 28.2373 36.2373Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.3152 15.29L56.5885 54.5634L54.4672 56.6847L15.1938 17.4114L17.3152 15.29Z",
			fill: "currentColor"
		})
	]
});
export default SvgHide;
